export function copy(data) {
  return JSON.parse(JSON.stringify(data));
}

export function etmsGetDecimalDefault(s) {
  if (s && typeof s == "string") {
    s = s.trim();
  }
  if (!s || s === "") {
    return "0";
  } else {
    return s;
  }
}
export function GetFormatDate(time) {
  let date;
  if (time) {
    date = new Date(time);
  } else {
    date = new Date();
  }
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let strDate = date
    .getDate()
    .toString()
    .padStart(2, "0");
  return `${date.getFullYear()}-${month}-${strDate}`;
}
export function GetFormatMonthDay(time) {
  let date;
  if (time) {
    date = new Date(time);
  } else {
    date = new Date();
  }
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let strDate = date
    .getDate()
    .toString()
    .padStart(2, "0");
  return `${month}-${strDate} `;
}
export function GetRecentDays(moment, subtractDays) {
  let date = [];
  let start = moment()
    .subtract(subtractDays, "days")
    .format("YYYY-MM-DD");
  let end = moment().format("YYYY-MM-DD");
  date.push(start);
  date.push(end);
  return date;
}

export function dateFormat(data) {
  let time = data.replace(/-/g, "/");
  time = new Date(time);
  var year = time.getFullYear() + "年";
  var month = time.getMonth() + 1 + "月";
  var date = time.getDate() + "日";
  return year + month + date;
}
/**
 * 设置全局缓存
 * @param {key} key
 * @param {加密信息} data
 * @param {非必选,过期时间,单位为分钟} expired
 */
export function setLocal(key, data, expired) {
  if (window.localStorage) {
    let param = {
      data: data,
      expired: new Date().getTime() + expired * 1000 * 60 || null
    };
    localStorage.setItem(key, JSON.stringify(param));
  }
}
/**
 * 获取全局缓存
 * @param {获取全局key} key
 */
export function getLocal(key) {
  if (window.localStorage) {
    let param = localStorage.getItem(key);
    if (param) {
      param = JSON.parse(param);
      if (param.expired && param.expired <= new Date().getTime()) {
        localStorage.removeItem(key);
        return null;
      } else {
        return param.data;
      }
    } else {
      return null;
    }
  }
}
/**
 *移除全局缓存
 * @param {缓存key} key
 */
export function removeLocal(key) {
  if (window.localStorage) {
    localStorage.removeItem(key);
  }
}
export function getQueryVariable(variable) {
  var query = window.location.href.split("?")[1];
  if (query.indexOf("&") != -1) {
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
  } else {
    var pair = query.split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }

  return false;
}
export function editKey(array, keyMap) {
  for (var i = 0; i < array.length; i++) {
    var obj = array[i];
    for (var key in obj) {
      var newKey = keyMap[key];
      if (newKey) {
        obj[newKey] = obj[key];
        delete obj[key];
      }
    }
  }
  return array;
}
/**
2  * 删除URL中的指定参数
3  * @param {*} url 
4  * @param {*} name 
5  */
export function delUrlParams(url, name) {
  //根据#号拆分
  let poundArr = url.split("#");
  //？拆分
  let questionArr = [];
  if (poundArr) {
    //把#接上
    poundArr.forEach((element, index) => {
      if (index > 0) {
        element = "#" + element;
      }

      let tempArr = element.split("?");
      if (!tempArr) {
        return true;
      }
      tempArr.forEach((item, idx) => {
        //保留问号
        if (idx > 0) {
          item = "?" + item;
        }
        questionArr.push(item);
      });
    });
  } else {
    questionArr = url.split("?");
    if (questionArr) {
      questionArr.forEach((item, idx) => {
        if (idx > 0) {
          item = "?" + item;
        }
      });
    }
  }
  if (!questionArr) {
    return url;
  }
  //&符号的处理
  let andArr = [];
  questionArr.forEach((item, index) => {
    let andIdx = item.indexOf("&");
    if (andIdx <= -1) {
      andArr.push(item);
      return true;
    }
    let tempAndArr = item.split("&");
    tempAndArr.forEach((ele, idx) => {
      if (idx > 0) {
        ele = "&" + ele;
      }
      andArr.push(ele);
    });
  });
  let newUrl = "";
  andArr.forEach(item => {
    let nameIndex = item.indexOf(name + "=");
    //不拼接要删除的参数
    if (nameIndex > -1) {
      //保留第一个问号
      let questionIdx = item.indexOf("?");
      if (questionIdx == 0) {
        newUrl += "?";
      }
      return true;
    }
    newUrl += item;
  });
  window.history.pushState({}, "", newUrl.replace(/\?\&/g, "?"));
}
export function GetQueryString(name) {
  var reg = eval("/" + name + "/g");
  var r = window.location.search.substr(1);
  var flag = reg.test(r);
  if (flag) {
    return true;
  } else {
    return false;
  }
}
export function urlDelParams(name) {
  var loca = window.location;
  var baseUrl = loca.origin + loca.pathname + "?";
  var query = loca.search.substr(1);
  if (query.indexOf(name) > -1) {
    var obj = {};
    var arr = query.split("&");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
    }
    delete obj[name];
    var url =
      baseUrl +
      JSON.stringify(obj)
        .replace(/[\"\{\}]/g, "")
        .replace(/\:/g, "=")
        .replace(/\,/g, "&");
    return url;
  }
}
export function urlDelFun(name) {
  const url = new URL(window.location); //获取到页面的url地址
  if (url.searchParams.has(name)) {
    url.searchParams.delete(name);
    window.history.replaceState({}, "", url);
  }
}

export function openUrl(url) {
  var a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("style", "display:none");
  a.setAttribute("target", "_blank");
  document.body.appendChild(a);
  a.click();
  a.parentNode.removeChild(a);
}

export function openUrl2(url) {
  var a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("style", "display:none");
  // a.setAttribute("target", "_blank");
  document.body.appendChild(a);
  a.click();
  a.parentNode.removeChild(a);
}

// export function openUrlFile(url, watermark) {
//   url = encodeURIComponent(url);
//   if (watermark) {
//     var tempWatermark = encodeURIComponent(watermark);
//     var myurl = `https://view.xdocin.com/view?src=${url}&watermark=${tempWatermark}`;
//     openUrl2(myurl);
//   } else {
//     var myurl = `https://view.xdocin.com/view?src=${url}`;
//     openUrl2(myurl);
//   }
// }

var webOfficeFile =
  "、doc、docx、txt、dot、wps、wpt、dotx、docm、dotm、rtf、ppt、pptx、pptm、ppsx、ppsm、pps、potx、potm、dpt、dps、et、xls、xlt、xlsx、xlsm、xltx、xltm、csv、pdf、";
export function openUrlFile(url, watermark) {
  var index = url.lastIndexOf(".");
  var ext = url.substr(index + 1);
  if (webOfficeFile.indexOf(`、${ext}、`) == -1) {
    openUrlFile2(url, watermark);
    return;
  }
  url = encodeURIComponent(url);
  if (watermark) {
    var tempWatermark = encodeURIComponent(watermark);
    var myurl = `https://pxb.yunvip123.com/#/officeWeb?src=${url}&watermark=${tempWatermark}`;
    openUrl2(myurl);
  } else {
    var myurl = `https://pxb.yunvip123.com/#/officeWeb?src=${url}`;
    openUrl2(myurl);
  }
}

export function openUrlFile2(url, watermark) {
  url = encodeURIComponent(url);
  if (watermark) {
    var tempWatermark = encodeURIComponent(watermark);
    var myurl = `https://view.xdocin.com/view?src=${url}&watermark=${tempWatermark}`;
    openUrl2(myurl);
  } else {
    var myurl = `https://view.xdocin.com/view?src=${url}`;
    openUrl2(myurl);
  }
}

export function getDatetime(a) {
  //获取时间并格式化字符串
  if (a) {
    var d = new Date(a);
  } else {
    var d = new Date();
  }
  var year = d.getFullYear();
  var month = change(d.getMonth() + 1);
  var day = change(d.getDate());
  var hour = change(d.getHours());
  var minute = change(d.getMinutes());
  function change(t) {
    if (t < 10) {
      return "0" + t;
    } else {
      return t;
    }
  }
  var time = year + "-" + month + "-" + day;
  return time;
}



// WEBPACK FOOTER //
// ./src/utils/com.js